const appProperties = {
    pageLinkSize: 3,
    rowsPerPageOptions: [10, 20, 50],
    pageSize: 10,
    sortOrder: 1,
    breadcrumbs: false,
    dateFormat: 'DD-MM-YYYY',
    apiDateFormat: 'YYYY/MM/DD',
    currentPageFirstRowIndex: 0,
    currentPageIndex: 0,
    totalRecordsCount: 0,
    timezone: 'Asia/Bangkok',
    maxInTime:'22',
    hourFormat: '24',
    appHome: '/home',
    errorPage: '/error',
    sessionTimeout: 3000,
    sessionTimeoutDialogShowbefore: 0.5,
    apiNotAuthorizedCode: 403,
    apiNotAuthorizedMessage: 'gen.nopermission.action',
    handleNotAuthorized: false,
    bypassSessionFrom: ['/login', '/user/reset'],
    appName: 'Espire Self Service Portal',
    modalProgressBar: true,
    multiLocaleEnabled: false,
    languageMenu: [{ locale: 'en', labelId: 'top.menu.english' }],
    defaultLocale: 'en',
    defaultTheme: 'espire-light',
    errorReportFileUploadMaxSize: 30000,
    errorReportFileUploadAccept: 'image/*',
    errorReportFileUploadNoOfFileLimit: 3,
    errorReportFileUploadAllowedFileTypes: 'gif|jpe?g|tiff?|png',
}

module.exports = appProperties
